// Bilingual translations for Kıbrıs Night Club
export const translations = {
  tr: {
    brand: "Kıbrıs Night Club",
    tagline: "Girne Night Club, Gece Hayatı, Cabaret & VIP Konsiyerj Rehberi",
    nav: {
      home: "Anasayfa",
      gallery: "Vitrin",
      services: "Hizmetler",
      pricing: "Fiyatlar",
      booking: "Rezervasyon",
      faq: "S.S.S.",
      blog: "Blog",
      contact: "İletişim",
    },
    common: {
      bookNow: "Hemen Rezervasyon",
      viewProfile: "Profili Gör",
      viewAll: "Tümünü Gör",
      whatsapp: "WhatsApp",
      call: "Ara",
      learnMore: "Daha Fazla",
      readMore: "Devamını Oku",
      back: "Geri",
      send: "Gönder",
      sending: "Gönderiliyor...",
      success: "Mesajınız başarıyla gönderildi.",
      error: "Bir hata oluştu, lütfen tekrar deneyin.",
      hour: "Saat",
      hours: "Saat",
      perHour: "/saat",
      age: "Yaş",
      height: "Boy",
      weight: "Kilo",
      bust: "Göğüs",
      languages: "Diller",
      nationality: "Milliyet",
      availability: "Müsaitlik",
      available: "Müsait",
      featured: "Öne Çıkan",
      new: "Yeni",
      vip: "VIP",
    },
    home: {
      heroEyebrow: "Girne • Kıbrıs • VIP Konsiyerj",
      heroTitle: "VIP Deneyimini Yaşa",
      heroSubtitle:
        "Girne Kıbrıs'ın en seçkin VIP konsiyerj, tur rehberliği ve etkinlik servisi. 7/24 çok dilli ekip, otel & restoran rezervasyonu, yat organizasyonu ve casino rehberliği.",
      ctaPrimary: "Hizmetleri Keşfet",
      ctaSecondary: "Bize Ulaş",
      aboutEyebrow: "Hakkımızda",
      aboutTitle: "Girne'nin premium konsiyerj ve etkinlik servisi",
      aboutText:
        "Kıbrıs Night Club, Girne'de VIP misafirlere yönelik konsiyerj, tur rehberliği ve etkinlik organizasyonu hizmeti veren butik bir servistir. Türkiye, Rusya, Ukrayna ve Avrupa'nın dört bir yanından çok dilli 24 profesyonel ekip üyemiz ile ziyaretinize eşsiz bir konfor katıyoruz. 5 yıldızlı otel rezervasyonu, restoran ve gece kulübü ayarlamaları, casino etiketi, yat kiralama, havalimanı transferi ve özel tur rehberliği için 7/24 hizmetinizdeyiz. Cratos, Merit, Acapulco ve tüm Girne otellerine profesyonel destek sunan Kuzey Kıbrıs'ın en güvenilir turizm konsiyerj adresidir.",
      featuredEyebrow: "Vitrin",
      featuredTitle: "Öne Çıkan Hizmetlerimiz",
      featuredSub:
        "Girne VIP konsiyerj hizmet paletimizden en çok tercih edilen paketler",
      servicesEyebrow: "Hizmetler",
      servicesTitle: "VIP Turizm ve Etkinlik Deneyimleri",
      whyEyebrow: "Neden Biz",
      whyTitle: "Girne Kıbrıs'ta Lider VIP Konsiyerj Servisi",
      whyItems: [
        {
          title: "%100 Diskret",
          desc: "Kişisel bilgileriniz ve tüm iletişimleriniz tam gizlilik ile ele alınır. Profesyonel diskretlik garantimizdir.",
        },
        {
          title: "Çok Dilli Ekip",
          desc: "Ekibimiz Türkçe, İngilizce, Rusça, Almanca, Fransızca, İtalyanca ve Arapça iletişim kurar. Uluslararası misafirler için ideal.",
        },
        {
          title: "7/24 Hizmet",
          desc: "Gece veya gündüz, dakikalar içinde rezervasyon organize edin. Girne ve çevresine 7/24 konsiyerj hizmeti.",
        },
        {
          title: "Lüks Otel Ağı",
          desc: "5 yıldızlı Girne otelleriyle güçlü işbirliği: rezervasyon önceliği, oda upgrade'i ve VIP misafir karşılama.",
        },
      ],
      ctaBannerTitle: "Girne'de VIP deneyimini kaçırma.",
      ctaBannerText:
        "Kıbrıs Night Club konsiyerj servisimizle otel, restoran, tur ve etkinlik organizasyonu için WhatsApp üzerinden anında iletişime geç.",
    },
    gallery: {
      title: "Hizmet Vitrini",
      subtitle: "Girne VIP Konsiyerj Vitrini — Sahne, Kulüp, Otel, Casino ve Yat",
      filterAll: "Tümü",
      filterNew: "Yeni",
      filterVip: "VIP",
      filterFeatured: "Öne Çıkanlar",
      empty: "Bu kategoride henüz hizmet yok.",
    },
    services: {
      title: "Hizmetlerimiz",
      subtitle:
        "Girne'de VIP misafirler için turizm, konsiyerj ve etkinlik hizmetleri",
      list: [
        {
          name: "Otel Rezervasyon & Konsiyerj",
          desc: "Girne'deki tüm 5 yıldızlı otellerde (Cratos, Merit, Acapulco, Concorde, Lord's Palace) rezervasyon önceliği, oda upgrade koordinasyonu ve VIP misafir karşılama servisi.",
        },
        {
          name: "Restoran & Gece Kulübü Rezervasyonu",
          desc: "Girne'nin en seçkin restoranlarında ve gece kulüplerinde VIP masa rezervasyonu, şef tarafından hazırlanan menü koordinasyonu ve özel kutlama organizasyonu.",
        },
        {
          name: "Casino Rehberliği & Etiket",
          desc: "Cratos, Merit ve Acapulco casinolarında ilk kez oynayanlara etiket rehberliği, oyun kuralları anlatımı ve çok dilli tercüme desteği. Yüksek limitli VIP salon erişimi için özel koordinasyon.",
        },
        {
          name: "Yat Kiralama & Deniz Organizasyonu",
          desc: "Girne Yat Limanı'ndan hareketli lüks yat kiralama, kaptan koordinasyonu, catering ve gün batımı turları. Karpaz kıyılarında özel koylara programlı rota planlaması.",
        },
        {
          name: "Havalimanı Transfer & Şehir Turu",
          desc: "Ercan / Larnaka havalimanından lüks araçla karşılama, otelinize diskret transfer ve şehir tanıtım turu. Çok dilli şoför-rehber eşliğinde tarihi Girne kalesi, St. Hilarion ve Karpaz turları.",
        },
        {
          name: "Kurumsal Etkinlik & Toplantı",
          desc: "İş toplantıları, kurumsal davetler ve konferanslar için mekan koordinasyonu, çok dilli hostesler, tercüme, çiçek ve şampanya servisi. Bekarlığa veda ve doğum günü paket seçenekleri de mevcuttur.",
        },
      ],
    },
    pricing: {
      title: "Paketler",
      subtitle:
        "Her paket kişisel ihtiyaca göre şekillendirilir. Aşağıdakiler yaklaşık aralıklardır — kesin fiyat için WhatsApp'tan iletişime geçin.",
      mostPopular: "En Çok Tercih Edilen",
      contactForCustom: "Özel paket teklifi için iletişime geç",
      plans: [
        {
          name: "Basic",
          duration: "Yarım Gün",
          price: "İsteğe Bağlı",
          features: [
            "Havalimanı transferi VEYA otel karşılama",
            "1 restoran veya casino rezervasyonu",
            "Çok dilli konsiyerj desteği",
            "WhatsApp ile 7/24 iletişim",
          ],
        },
        {
          name: "Premium",
          duration: "Tam Gün",
          price: "İsteğe Bağlı",
          highlight: true,
          features: [
            "Havalimanı transferi + otel karşılama",
            "Restoran + gece kulübü rezervasyonu",
            "Casino etiket rehberliği",
            "Öncelikli oda upgrade koordinasyonu",
            "Çok dilli asistan (TR/EN/RU)",
          ],
        },
        {
          name: "Signature",
          duration: "Çoklu Gün",
          price: "İsteğe Bağlı",
          features: [
            "Tam konsiyerj paketi (3+ gün)",
            "Yat kiralama & Karpaz turu",
            "Şehir turu ve tarihi mekan rehberi",
            "Özel etkinlik & kutlama organizasyonu",
            "Kişiye özel VIP asistan tayini",
          ],
        },
      ],
      note: "Fiyatlandırma paketin süresine, misafir sayısına ve seçilen hizmetlere göre değişir. Kesin teklif için WhatsApp üzerinden iletişime geçin.",
    },
    faq: {
      title: "Sıkça Sorulan Sorular",
      subtitle:
        "Girne VIP konsiyerj ve etkinlik hizmetimiz hakkında merak edilenler",
    },
    contact: {
      title: "İletişim",
      subtitle:
        "Girne VIP konsiyerj rezervasyonu ve etkinlik organizasyonu için 7/24 ulaşılabiliriz.",
      whatsappTitle: "WhatsApp ile Anında Yanıt",
      whatsappText:
        "En hızlı yanıt için WhatsApp üzerinden yazın. Tüm talepler diskret ve özel olarak ele alınır.",
      callTitle: "Telefonla Ara",
      addressTitle: "Konum",
      address: "Girne, Kuzey Kıbrıs",
      formTitle: "Bize Mesaj Bırakın",
      formName: "Adınız",
      formPhone: "Telefonunuz",
      formMessage: "Mesajınız",
      formSubmit: "Mesajı Gönder",
      hoursTitle: "Çalışma Saatleri",
      hoursValue: "7/24 Hizmet",
    },
    blog: {
      title: "Blog",
      subtitle:
        "Kuzey Kıbrıs lüks turizm ve konsiyerj dünyasından haberler, rehberler ve hikayeler",
      back: "Tüm yazılar",
      relatedTitle: "İlgili Yazılar",
    },
    footer: {
      tagline: "Girne Kıbrıs'ın en seçkin VIP konsiyerj ve etkinlik servisi.",
      quickLinks: "Hızlı Bağlantılar",
      services: "Hizmetler",
      contact: "İletişim",
      disclaimer:
        "Kıbrıs Night Club, Kuzey Kıbrıs'ta lisanslı turizm, etkinlik ve konsiyerj servisi olarak çalışır. Tüm hizmetlerimiz yasalara uygundur.",
      rights: "Tüm hakları saklıdır.",
    },
  },
  en: {
    brand: "Kıbrıs Night Club",
    tagline: "Kyrenia Nightclub, Nightlife, Cabaret & VIP Concierge Guide",
    nav: {
      home: "Home",
      gallery: "Showcase",
      services: "Services",
      pricing: "Pricing",
      booking: "Booking",
      faq: "FAQ",
      blog: "Blog",
      contact: "Contact",
    },
    common: {
      bookNow: "Book Now",
      viewProfile: "View Profile",
      viewAll: "View All",
      whatsapp: "WhatsApp",
      call: "Call",
      learnMore: "Learn More",
      readMore: "Read More",
      back: "Back",
      send: "Send",
      sending: "Sending...",
      success: "Your message has been sent successfully.",
      error: "An error occurred, please try again.",
      hour: "Hour",
      hours: "Hours",
      perHour: "/hr",
      age: "Age",
      height: "Height",
      weight: "Weight",
      bust: "Bust",
      languages: "Languages",
      nationality: "Nationality",
      availability: "Availability",
      available: "Available",
      featured: "Featured",
      new: "New",
      vip: "VIP",
    },
    home: {
      heroEyebrow: "Kyrenia • Cyprus • VIP Concierge",
      heroTitle: "Live The VIP Experience",
      heroSubtitle:
        "Kyrenia's most exclusive VIP concierge, tour guiding and event service. A 24/7 multilingual team for hotel & restaurant reservations, yacht organisation and casino etiquette.",
      ctaPrimary: "Explore Services",
      ctaSecondary: "Contact Us",
      aboutEyebrow: "About Us",
      aboutTitle: "Kyrenia's premium concierge and event service",
      aboutText:
        "Kıbrıs Night Club is a boutique concierge, tour-guiding and event-organisation service for VIP visitors to Kyrenia, Northern Cyprus. Our 24 multilingual professional team members — from Türkiye, Russia, Ukraine and across Europe — add unmatched comfort to your visit. We are available 24/7 for 5-star hotel reservations, restaurant and nightclub arrangements, casino etiquette, yacht charter, airport transfers and private tour guiding. With professional support at Cratos, Merit, Acapulco and every Kyrenia hotel, we are Northern Cyprus's most trusted tourism concierge address.",
      featuredEyebrow: "Showcase",
      featuredTitle: "Our Featured Services",
      featuredSub:
        "The most requested packages from our Kyrenia VIP concierge palette",
      servicesEyebrow: "Services",
      servicesTitle: "VIP Tourism & Event Experiences",
      whyEyebrow: "Why Us",
      whyTitle: "Leading VIP Concierge Service in Kyrenia Cyprus",
      whyItems: [
        {
          title: "100% Discreet",
          desc: "Your personal information and all communication are handled with full confidentiality. Professional discretion is our guarantee.",
        },
        {
          title: "Multilingual Team",
          desc: "Our team communicates in Turkish, English, Russian, German, French, Italian and Arabic. Ideal for international guests.",
        },
        {
          title: "24/7 Service",
          desc: "Day or night, organise reservations within minutes. 24/7 concierge coverage in Kyrenia and surroundings.",
        },
        {
          title: "Luxury Hotel Network",
          desc: "Strong partnerships with 5-star Kyrenia hotels: reservation priority, room upgrades and VIP welcome.",
        },
      ],
      ctaBannerTitle: "Don't miss the VIP experience in Kyrenia.",
      ctaBannerText:
        "Reach us on WhatsApp for hotel, restaurant, tour and event coordination with our concierge service.",
    },
    gallery: {
      title: "Service Showcase",
      subtitle: "Our Kyrenia VIP Showcase — Stage, Club, Hotels, Casino and Yacht",
      filterAll: "All",
      filterNew: "New",
      filterVip: "VIP",
      filterFeatured: "Featured",
      empty: "No services in this category yet.",
    },
    services: {
      title: "Our Services",
      subtitle:
        "Tourism, concierge and event services for VIP visitors in Kyrenia",
      list: [
        {
          name: "Hotel Booking & Concierge",
          desc: "Priority reservations, room upgrade coordination and VIP welcome service across every 5-star hotel in Kyrenia (Cratos, Merit, Acapulco, Concorde, Lord's Palace).",
        },
        {
          name: "Restaurant & Nightclub Reservations",
          desc: "VIP table reservations at Kyrenia's finest restaurants and nightclubs, chef-curated menu coordination and private celebration organisation.",
        },
        {
          name: "Casino Guide & Etiquette",
          desc: "Etiquette guidance, rules explanation and multilingual translation support for first-time players at Cratos, Merit and Acapulco casinos. Private coordination for high-limit VIP salons.",
        },
        {
          name: "Yacht Charter & Sea Organisation",
          desc: "Luxury yacht charter from Kyrenia Marina, captain coordination, catering and sunset cruises. Programmed routes to private coves along the Karpaz coast.",
        },
        {
          name: "Airport Transfer & City Tour",
          desc: "Luxury pickup from Ercan / Larnaca airport, discreet transfer to your hotel and city introduction tour. Multilingual driver-guide for tours of historic Kyrenia castle, St. Hilarion and Karpaz.",
        },
        {
          name: "Corporate Event & Meeting",
          desc: "Venue coordination, multilingual staff, translation, flowers and champagne service for business meetings, corporate events and conferences. Bachelor and birthday package options also available.",
        },
      ],
    },
    pricing: {
      title: "Packages",
      subtitle:
        "Every package is tailored to individual needs. Below are indicative tiers — contact us on WhatsApp for a firm quote.",
      mostPopular: "Most Requested",
      contactForCustom: "Request a custom package quote",
      plans: [
        {
          name: "Basic",
          duration: "Half Day",
          price: "On Request",
          features: [
            "Airport transfer OR hotel welcome",
            "1 restaurant or casino reservation",
            "Multilingual concierge support",
            "24/7 WhatsApp assistance",
          ],
        },
        {
          name: "Premium",
          duration: "Full Day",
          price: "On Request",
          highlight: true,
          features: [
            "Airport transfer + hotel welcome",
            "Restaurant + nightclub reservations",
            "Casino etiquette guidance",
            "Priority room upgrade coordination",
            "Multilingual assistant (TR/EN/RU)",
          ],
        },
        {
          name: "Signature",
          duration: "Multi-Day",
          price: "On Request",
          features: [
            "Full concierge package (3+ days)",
            "Yacht charter & Karpaz tour",
            "City tour & heritage guide",
            "Private event & celebration organisation",
            "Dedicated VIP personal assistant",
          ],
        },
      ],
      note: "Pricing depends on package length, guest count and selected services. Contact us on WhatsApp for a firm quote.",
    },
    faq: {
      title: "Frequently Asked Questions",
      subtitle:
        "Everything you need to know about our Kyrenia VIP concierge service",
    },
    contact: {
      title: "Contact",
      subtitle: "Available 24/7 for your Kyrenia VIP concierge inquiry.",
      whatsappTitle: "Instant Reply on WhatsApp",
      whatsappText:
        "For the fastest reply, message us on WhatsApp. Every inquiry is handled with full discretion.",
      callTitle: "Call Us",
      addressTitle: "Location",
      address: "Kyrenia, Northern Cyprus",
      formTitle: "Send us a message",
      formName: "Your name",
      formPhone: "Your phone",
      formMessage: "Your message",
      formSubmit: "Send Message",
      hoursTitle: "Hours",
      hoursValue: "24/7 Service",
    },
    blog: {
      title: "Blog",
      subtitle:
        "News, guides and stories from the Kyrenia luxury tourism & concierge scene",
      back: "All posts",
      relatedTitle: "Related Posts",
    },
    footer: {
      tagline: "Kyrenia's most exclusive VIP concierge and event service.",
      quickLinks: "Quick Links",
      services: "Services",
      contact: "Contact",
      disclaimer:
        "Kıbrıs Night Club operates as a licensed tourism, event and concierge service provider in Northern Cyprus. All our services are legal.",
      rights: "All rights reserved.",
    },
  },
};
